import React from 'react'
import './LRTableActions.css'

const LRTableActionsUI = ({context, className, location, left, right}) =>
  <div className={`w_lr_tbl_a g_flex_h ${className ? className : ''} ${location ? location : ''}`}>
    {left}
    {right}
  </div>

export default LRTableActionsUI
